<template>
  <el-container class="index_content">
    <el-container>
      <div class="mainContent">
        <el-main class="mainclass">
          <MonthlyStatement v-if="$route.query.type == 'month_state'">
          </MonthlyStatement>
          <el-tabs v-model="activeTitle" type="card" @tab-click="handleClick" v-else
            :id="activeTitle == 'course' ? 'coursestyle' : ''" style="background-color: #fff;">
            <el-tab-pane label="Home" name="home">

            </el-tab-pane>
            <el-tab-pane label="Upcoming Classes" name="schedule" class="">

            </el-tab-pane>
            <el-tab-pane label="Past Classes" name="lesson">
            </el-tab-pane>
            <el-tab-pane label="Calendar" name="calendar">

            </el-tab-pane>
            <el-tab-pane label="Open Slots" name="time">
            </el-tab-pane>
            <el-tab-pane label="Personal Center" name="mine">
            </el-tab-pane>
          </el-tabs>
          <Home v-if="activeTitle == 'home'&&!$route.query.type" @editActive="editActive"/>
          <past-lesson :data-lesson="lessonData" @page-num="pagenumEvent" v-if="activeTitle == 'lesson'"></past-lesson>
          <full-calendar :events="events" v-loading="loading" ref="calendar" :config="config" v-if="activeTitle == 'calendar'" style="background-color: #fff;margin-top: 20px;padding: 30px 200px 30px"></full-calendar>
          <FreeTime v-if="activeTitle == 'time'"/>
          <div v-if="activeTitle == 'schedule'" class="schedule_">
            <div class="form-search flex_end">
                <el-date-picker v-model="timeRang" type="daterange" range-separator="/" align="left"
                  value-format="yyyy-MM-dd" start-placeholder="Select a date" end-placeholder="date range"
                  :picker-options="pickerOptions" @change="search">
                </el-date-picker>
                <a class="clearBtn font_18_bold" @click="resetFilter()">Reset filter</a>
              </div>
              <div class="courseForm">
                <p class="font_16 color_grey c6B7280">
                  Showing: {{ statusName }}
                </p>
                <div class="courseList" v-for="(item, i) in scheduleData" :key="i">
                  <p class="font_24_bold color_black datestyle">
                    {{ item.date }}
                  </p>
                  <div class="classList" v-for="(lessonItem, j) in item.data" :key="j">
                    <div class="titleName flex_start" style="margin-bottom: 17px">
                      <img :src="lessonItem.subject_img" />
                      <div class="flex_1 flex_column_start">
                        <div class="flex_between">
                          <h3 class="font_24_24_reg start_endtime">
                            {{ lessonItem.start_at_time }} -{{
                              lessonItem.end_at_time
                            }}
                          </h3>
                          <button :class="lessonItem.mins
                            ? 'willStartIn'
                            : lessonItem.status == 1 && !lessonItem.mins
                              ? 'pending'
                              : lessonItem.status == 2
                                ? 'completed'
                                : 'btnNone'
                            ">
                            {{
                              lessonItem.mins
                                ? "Starts in " + lessonItem.mins
                                : lessonItem.status == 1 && !lessonItem.mins
                                  ? "On Air"
                                  : lessonItem.status == 2
                                    ? "Completed"
                                    : ""
                            }}
                          </button>
                        </div>
                        <div class="card_tr">
                          <span class="card_subtitle">{{
                            lessonItem.subtitle
                          }}</span>
                          <span class="card_lessons">{{ lessonItem.start_lessons }}/{{
                            lessonItem.total_lessons
                          }}</span>
                          <button class="card_leveltitle">
                            {{ lessonItem.leveltitle }}
                          </button>
                          <p class="color_ora card_student">
                            {{ lessonItem.is_trial ? "Trial student" : "" }}
                          </p>
                          <button v-if="lessonItem.status == 0" class="card_levelbtn" @click="handleCancel(lessonItem)">
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="flex_center topic" v-if="lessonItem.lesson_topic">
                      <p class="classTopic font_18_reg weight600">Topic:</p>
                      <p class="font_16">{{ lessonItem.lesson_topic }}</p>
                    </div>

                    <div class="classTimeInfo">
                      <div class="studentList" v-if="lessonItem.student.length > 0">
                        <p :title="studentItem.nickname" v-for="(studentItem, k) in lessonItem.student" :key="k"
                          :class="studentItem.is_trial == 1 ? 'trial' : ''">
                          {{
                            studentItem.nickname +
                            (studentItem.is_trial == 1 ? "*" : "")
                          }}
                        </p>
                      </div>
                      <div class="actBtn flex_center">
                        <button type="text" @click="enterClassRoom(lessonItem.lesson_sn)" :disabled="lessonItem.status == 2 ||
                          (lessonItem.status == 0 && !lessonItem.enterStatus)
                          " :class="lessonItem.status == 2 ||
                            (lessonItem.status == 0 && !lessonItem.enterStatus)
                            ? 'disabled enterBtn'
                            : 'enterClass enterBtn'
                            ">
                          <!--                                :class="lessonItem.status!=2&&lessonItem.enterStatus?'enterClass enterBtn':'disabled enterBtn'"-->
                          Enter Classroom
                        </button>
                        <button type="text" v-if="lessonItem.comment_status == 1"
                          @click="open(lessonItem, 1)" :disabled="lessonItem.status == 0" :class="lessonItem.status == 0 ? 'disabled' : 'leaveBtn'
                            ">
                          Edit Your Note
                        </button>
                        <button type="text" v-else @click="open(lessonItem, 0)"
                          :disabled="lessonItem.status == 0" :class="lessonItem.status == 0 ? 'disabled' : 'leaveBtn'
                            ">
                          Leave a Note
                        </button>
                        <button type="text" @click="toCourseware(lessonItem.courseware_url)"
                          :disabled="!lessonItem.courseware_url" :class="!lessonItem.courseware_url ? 'disabled' : 'leaveBtn'
                            ">
                          View Lesson Material
                        </button>
                        <button type="text" @click="openPre(lessonItem)" v-if="lessonItem.pre_class_notes" class="leaveBtn">
                          Pre-class Notes
                        </button>
                      </div>
                    </div>
                    <p class="mt" v-if="!(lessonItem.status == 1 && !lessonItem.mins)">
                      Enter the classroom 15 minutes before class starts
                    </p>
                  </div>
                </div>
              </div>
              <el-pagination v-if="total > 0" @current-change="handleCurrentChange" :current-page="pageNum"
                :page-size="pagesize" layout="prev, pager, next" :total="total">
              </el-pagination>
          </div>
          <Mine v-if="activeTitle == 'mine'"/>
        </el-main>
      </div>
    </el-container>
    <el-dialog title="Preferred Name" :visible.sync="dialogVisible" width="600px" :before-close="handleClose"
      custom-class="editNameDialog">
      <el-input v-model="newAlias" placeholder="Please enter the Preferred Name"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="eidtAlias">Confirm</el-button>
      </span>
    </el-dialog>
    <el-dialog title="Confirm cancel this class" :visible.sync="canceldialogVisible" width="35%"
      :before-close="cancelhandleClose" custom-class="cancelDialog">
      <span v-if="showTimetip2">Are you sure to cancel?</span>
      <span v-if="showTimetip1">Cancelling this lesson (<24 hours notice) will affect your payment for this
          session</span>
          <p style="margin-top: 10px" v-if="showTimetip1">
            Proceed with cancellation ?
          </p>
          <span slot="footer" class="dialog-footer">
            <el-button class="cancelbtn1" v-if="showTimetip2" @click="tohandleCanceldialog">Confirm</el-button>
            <el-button class="Confirmbtn1" v-if="showTimetip2" @click="canceldialogVisible = false">Cancel</el-button>
            <el-button class="cancelbtn1" v-if="showTimetip1" @click="tohandleCanceldialog">Yes,Cancel
              Lesson</el-button>
            <el-button class="Confirmbtn1" v-if="showTimetip1" @click="canceldialogVisible = false">No,Keep
              Lesson</el-button>
          </span>
    </el-dialog>
  </el-container>
</template>
<script>
import store from "@/store/store";
import { getToday } from "../utils/utils";
import IndexHeader from "./views/header";
import PastLesson from "./views/lesson";
import MyCourse from "./views/course";
import EarningRecord from "./views/record";
import MonthlyStatement from "./views/MonthlyStatement";
import FreeTime from "./views/FreeTime";
import FreeTimes from "./views/FreeTimes.vue";
import Home from "./views/Home.vue";
import Mine from "./views/Mine.vue";
export default {
  components: {
    IndexHeader,
    PastLesson,
    MyCourse,
    EarningRecord,
    MonthlyStatement,
    FreeTime,
    FreeTimes,
    Home,
    Mine
  },
  data() {
    return {
      showTimetip1: false,
      showTimetip2: false,
      cancellesson: "",
      //存储删除课程的lesson_sn
      canceldialogVisible: false, //取消弹框
      data: [],
      interval: null,
      statusName: "",
      scheduleData: [],
      activeTitle: "home" /* calendar */,
      timeRang: Array.apply(null, Array(2)).map(() => ""), // 日期范围
      courseData: [],
      lessonData: {},
      pagenum: 1,
      pageNum: 1,
      total: 0,
      pagesize: 10,
      recordpagenum: 1,
      pickerOptions: {
        disabledDate(time) {
          // 此条为设置禁止用户选择今天之前的日期，包含今天。
          // return time.getTime() <= (Date.now());
          // 此条为设置禁止用户选择今天之前的日期，不包含今天。
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      remind: true,
      newAlias: "",
      dialogVisible: false,

      events: [],
      config: {
        header: {
          left: "prev,next today",
          center: "title",
          right: "month,agendaWeek,agendaDay,list",
        },
        buttonText: {
          today: "Today",
          month: "Month",
          week: "Week",
          day: "Day",
          list: "List",
        },
        locale: "en",
        firstDay: 1,
        height: "auto", // 设置日历的高度，包括header日历头部，默认未设置，高度根据aspectRatio值自适应。
        defaultView: "month", // 显示默认视图
        // contentHeight://设置日历主体内容的高度，不包括header部分，默认未设置，高度根据aspectRatio值自适应。
        aspectRatio: 1.35, // 设置日历单元格宽度与高度的比例。
        // weekMode: 'liquid',
        // weekNumbers: true,
        slotEventOverlap: true,
        timeFormat: "HH:mm",
        navLinks: true, // can click day/week names to navigate views
        eventLimit: 3, // 限制一天中显示的事件数，默认false
        allDaySlot: false,
        // allDayText: '排班',   // 日历上显示全天的文本
        editable: true,
        selectable: false, // 允许用户通过单击或拖动选择日历中的对象，包括天和时间。
        selectHelper: true, // 当点击或拖动选择时间时，显示默认加载的提示信息，该属性只在周/天视图里可用。
        unselectAuto: true, // 当点击页面日历以外的位置时，自动取消当前的选中状态。
        eventBackgroundColor: "#FFF3C1", // 设置日程事件的背景色
        select: this.selectHandler,
        eventClick: this.eventClick,
        eventRender: function (event, element, view) {
          // 当Event对象开始渲染时触发
          if (view.type == "month") {
            element.html(event.time + "<br><i>" + event.title + "</i>");
          } else if (view.type == "agendaWeek") {
            element.html("<i>" + event.time + "&nbsp;" + event.title + "</i>");
          } else if (view.type == "agendaDay") {
            element.html(event.time + "&nbsp;&nbsp;" + event.title);
          } else if (view.type == "list") {
            element.html(
              '<td class="fc-list-item-time fc-widget-content">' +
              event.time +
              "</td>" +
              '<td class="fc-list-item-marker fc-widget-content"><span class="fc-event-dot" style="background-color:#FFF3C1"></span></td>' +
              '<td class="fc-list-item-title fc-widget-content"><a>' +
              event.title +
              "</a></td>"
            );
          }
        },
      },
      loading: false,
      value5: "",
      pl: "",
    };
  },
  created() {
    if (!this.utils.getCookie("pc_token")) {
      this.$router.push({
        path: "/",
      });
      return false;
    }
    // 用户信息
    this.$http
      .get("/tutor/api/getGlobalInfo?time=" + this.utils.timeZone())
      .then((res) => {
        if (res.data.code == 200) {
          this.data = res.data.data;
          this.value5 = this.data.rating_total;
          this.pl = this.data.rating_num;
          this.remind = res.data.data.is_sms == "1";
          // 存储头像至本地缓存
          sessionStorage.setItem('avatar',res.data.data.avatar)
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
          });
        }
      })
      .catch((error) => {
        console.log(error); // 请求失败返回的数据
      });
    // 搜索全部正在上和还没上的课
    this.search();
    this.changeMonth();
  },
  mounted(){
    if(this.$route.query.type == 'mine'){
      this.activeTitle = 'mine'
    }
  },
  methods: {
    openPre(lessonItem){
      this.$http.post("/tutor/api/readClassNotes", {
        lesson_sn: lessonItem.lesson_sn,
      })
        .then(res => {
          this.$confirm(lessonItem.pre_class_notes, 'Pre-class Notes', {
            confirmButtonText: 'OK',
            customClass: "Pre-class",
            showCancelButton:false
          }).then(() => {
          }).catch(action => {
          });
        })
    },
    editActive(newvalue){
      this.activeTitle=newvalue;
      this.handleClick(newvalue)
    },
    tohandleCanceldialog() {
      this.$http
        .post("/tutor/api/cancelClass", {
          lesson_sn: this.cancellesson,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.search();
          }
        });
      this.canceldialogVisible = false;
    },
    // 删除课程弹框
    handleCancel(lessonItem) {
      const startTime = new Date(lessonItem.start_at).getTime();
      const currentTime = new Date().getTime();
      const timeDiff = startTime - currentTime;
      if (timeDiff > 0 && timeDiff < 86400000) {
        // 小于24小时
        this.showTimetip1 = true;
        this.showTimetip2 = false;
      } else {
        // 大于等于24小时
        this.showTimetip1 = false;
        this.showTimetip2 = true;
      }
      this.cancellesson = lessonItem.lesson_sn;
      this.canceldialogVisible = true;
    },
    getToday() {
      const date = new Date(new Date().getTime());
      // 获取年、月、日
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始，所以要加1
      const day = String(date.getDate()).padStart(2, "0");
      // 组合成 "YYYY-MM-DD" 格式
      return `${year}-${month}-${day}`;
    },
    changeMonth(start, end, current) {
      this.loading = true;
      // 获取当前天
      let totay = this.getToday();
      this.$http
        .get(
          "/tutor/api/getTeacherCalendar?date_type=1&time=" +
          this.utils.timeZone()
        )
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.data.lesson_data.length > 0) {
              res.data.data.lesson_data.forEach((item, i) => {
                this.events.push({
                  id: i,
                  title: item.subject_title,
                  start: item.start_at,
                  time: item.time,
                  level_title: item.level_title,
                  className:
                    item.start_at.slice(0, 10) == totay ? "isToday" : "",
                });
                if (i == res.data.data.lesson_data.length - 1) {
                  this.loading = false;
                }
              });
            } else {
              this.loading = false;
            }
          } else {
            this.loading = false;
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
    handleCommand(command) {
      if (command == "Reset") {
        this.$router.push({ path: "/resetPassword" });
      } else {
        this.$router.push({ path: "/" });
      }
    },
    handleClick(tab, event) {
      if (tab.name == "course"||tab == "course") {
        this.$http
          .get("/tutor/api/myCoures?time=" + this.utils.timeZone())
          .then((res) => {
            if (res.data.code == 200) {
              this.courseData = res.data.data;
            } else {
              this.$message({
                message: res.data.msg,
                type: "warning",
              });
            }
          })
          .catch((error) => {
            console.log(error); // 请求失败返回的数据
          });
      } else if (tab.name == "schedule"||tab == "schedule") {
        this.search();
      } else if (tab.name == "lesson"||tab == "lesson") {
        this.getLesson();
      } else if (tab.name == "calendar"||tab == "calendar") {
        this.events=[]
        this.changeMonth();
        // this.$router.push({ path: '/calendar' })
      } else if (tab.name == 'home'||tab == "home") {
        this.$router.push({path:'/index'})
      }
    },
    search() {
      // 我的时间表
      this.$http
        .get(
          "/tutor/api/mySchedule?start_date=" +
          this.timeRang[0] +
          "&pagesize=" +
          this.pagesize +
          "&page=" +
          this.pageNum +
          "&end_date=" +
          this.timeRang[1] +
          "&time=" +
          this.utils.timeZone()
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.statusName = res.data.data.now_status;
            this.scheduleData = res.data.data.datas;
            this.total = res.data.total;
            if (this.interval) {
              // 判断定时器这个属性是否为空,存在则清除
              clearInterval(this.interval);
            }
            this.interval = setInterval(() => {
              // 这个interval是在data(){return{}} 中创建，初始化为null 防止重复请求到这个页面定时器重复生成
              this.timeStatus();
              this.$forceUpdate();
            }, 1000);
            // })
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        })
        .catch((error) => {
          console.log(error); // 请求失败返回的数据
        });
    },
    getLesson() {
      this.$http
        .get(
          "/tutor/api/psatLesson?pagesize=" +
          this.pagesize +
          "&page=" +
          this.pagenum +
          "&time=" +
          this.utils.timeZone()
        )
        .then((res) => {
          if (res.data.code == 200) {
            console.log(res);
            this.lessonData = res.data.data;
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        })
        .catch((error) => {
          console.log(error); // 请求失败返回的数据
        });
    },
    resetFilter() {
      this.timeRang = Array.apply(null, Array(2)).map(() => "");
      this.search();
    },
    open(lessonItem, type) {
      this.$prompt(
        "Your note will help us evaluate the students learning progress and provide them the best learning experience.<p>Note:</p>",
        "Note for the lesson",
        {
          confirmButtonText: "Submit Comment",
          customClass: "noteClass",
          // confirmButtonClass:'submitNote',
          showCancelButton: false,
          dangerouslyUseHTMLString: true,
          inputType: "textarea",
          inputPlaceholder: "Type your note here: ",
          inputValue: lessonItem.comnents,
        }
      )
        .then(({ value }) => {
          if (value != "") {
            if (type == 0) {
              this.$http
                .post("/tutor/api/addTeacherComment", {
                  comment: value,
                  teacher_sn: lessonItem.teacher_sn,
                  lesson_sn: lessonItem.lesson_sn,
                  class_sn: lessonItem.class_sn,
                })
                .then((res) => {
                  if (res.data.code == 200) {
                    this.$message({
                      message: res.data.data,
                      type: "success",
                    });
                    this.alertMsg();
                  } else {
                    this.$message({
                      message: res.data.msg,
                      type: "warning",
                    });
                  }
                })
                .catch((error) => {
                  console.log(error); // 请求失败返回的数据
                });
            } else {
              this.$http
                .post("/tutor/api/addTeacherComment", {
                  comment: value,
                  teacher_sn: lessonItem.teacher_sn,
                  lesson_sn: lessonItem.lesson_sn,
                  class_sn: lessonItem.class_sn,
                })
                .then((res) => {
                  if (res.data.code == 200) {
                    this.$message({
                      message: res.data.data,
                      type: "success",
                    });
                    this.alertMsg();
                  } else {
                    this.$message({
                      message: res.data.msg,
                      type: "warning",
                    });
                  }
                })
                .catch((error) => {
                  console.log(error); // 请求失败返回的数据
                });
            }
          }
        })
        .catch((error) => {
          this.$message({
            type: "info",
            message: error,
          });
        });
    },
    alertMsg() {
      this.$alert(
        '<p style="font-size:30px;text-align: center;margin: 55px 0;">Thank you! Note Received.</p>',
        "",
        {
          confirmButtonText: "Back to Main Page",
          dangerouslyUseHTMLString: true,
          callback: (action) => {
            this.search();
          },
        }
      );
    },
    timeStatus() {
      for (var i in this.scheduleData) {
        var item = this.scheduleData[i].data;
        item.map((timeItem, k) => {
          var hoursRound = "";
          var minutesRound = "";
          let beg = this.utils.formatDate(timeItem.start_at_utc).getTime(); // 开始秒数
          let now = this.utils.formatDate(timeItem.now_time_utc).getTime(); // 时区秒数

          let begTime = beg - now;

          let begTime2 = (timeItem.start_at_timestamp - timeItem.now_time_timestamp) * 1000

          if (begTime2 >= 0 && begTime2 < 172800000) {
            hoursRound = Math.floor(begTime2 / 1000 / 60 / 60);
            minutesRound = Math.floor((begTime2 / 1000 / 60) % 60);
            if (hoursRound == 0 && minutesRound == 0) {
              timeItem.mins = null;
            } else {
              timeItem.mins = hoursRound + " hours " + minutesRound + " mins";
            }
          }else if (begTime2 < 0) {
            timeItem.mins = null;
          }

          if (begTime < 900000) {
            timeItem.enterStatus = true;
          }
        });
      }
      return this.scheduleData;
    },
    enterClassRoom(lesson_sn) {
      this.$http
        .get("/tutor/api/lesson/teacherEntry/" + lesson_sn)
        .then((res) => {
          if (res.data.code == 200) {
            window.open(res.data.url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        })
        .catch((error) => {
          console.log(error); // 请求失败返回的数据
        });
    },
    pagenumEvent(num) {
      this.pagenum = num;
      this.getLesson();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.search();
    },
    remindEvent() {
      this.$http
        .post("/tutor/api/setTeacherSmsStatus", {
          is_sms: this.remind ? "1" : "0",
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.remind = res.data.data.is_sms == "1";
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        })
        .catch((error) => {
          console.log(error); // 请求失败返回的数据
        });
    },
    toCourseware(url) {
      window.open(url, "_blank");
    },
    eidtAlias() {
      this.$http
        .post("/tutor/api/setTeacherAlias", {
          alias: this.newAlias,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.dialogVisible = false;
            this.data.alias = this.newAlias;
            this.newAlias = "";
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        })
        .catch((error) => {
          console.log(error); // 请求失败返回的数据
        });
    },
    handleClose() {
      this.dialogVisible = false;
      this.newAlias = "";
    },
    cancelhandleClose() {
      this.canceldialogVisible = false;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-tabs__content{
  display: none !important;
}
.usersreviews {
  display: flex;
  margin-bottom: 10px;
  flex-direction: column;
  text-align: center;

  span {
    margin-left: 10px;
    height: 22px;
    padding-top: 2px;
    font-family: Arial;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    display: inline-block;
    margin-top: 10px;
    color: #999999;
  }
}

.index_content {
  .el-container {
    background-color: #fff8d0;
    // min-height: calc(100vh - 64px);
  }

  .mainContent {
    display: flex;
    margin: 25px auto 54px;

    .el-aside {
      .box {
        background: #ffffff;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
        padding: 24px;
        border-radius: 16px;

        .id {
          font-family: Arial;
          font-size: 14px;
          font-weight: normal;
          line-height: 20px;
          letter-spacing: 0px;
          color: #999999;
        }
      }

      h3 {
        font-size: 24px;
        font-family: Arial;
        font-weight: 700;
        color: #353643;
        letter-spacing: 0px;
        display: flex;
        justify-content: space-between;
        line-height: 28px;
        align-items: center;
      }

      .timeZoneAside {
        height: 44px;
        border-radius: 6px;
        font-family: Arial;
        font-size: 14px;
        font-weight: bold;
        line-height: 20px;
        letter-spacing: 0px;
        font-variation-settings: "opsz" auto;
        color: #333333;
        margin-top: 24px;
      }

      .userAside {

        //padding:16px 28px;
        .userAside_img {
          width: 100px;
          height: 80px;
          margin: 0px auto;
          margin-bottom: 20px;

          >img {
            width: 80px;
            height: 80px;
            border-radius: 50%;
          }
        }

        .contactlist {
          img {
            width: 16px;
            //height:16px;
          }

          .lineInfo {
            margin-left: 14px;
          }

          .informaInfo {
            margin-top: 16px;
            display: flex;
            align-items: center;

            span {
              font-family: Arial;
              font-size: 14px;
              font-weight: normal;
              line-height: 20px;
              letter-spacing: 0px;

              color: #666666;
            }

            p {
              font-family: Arial;
              font-size: 16px;
              font-weight: normal;
              line-height: 24px;
              letter-spacing: 0px;

              color: #333333;
            }
          }
        }

        // .monthInfo{
        .remindbox {
          height: 90px;
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          margin-top: 20px;
          border-top: 1px solid #f8f8f8;

          font-family: Arial;
          font-size: 14px;
          font-weight: normal;
          line-height: 20px;
          letter-spacing: 0px;

          color: #666666;
        }
      }
    }

    .schedule_ {
      background-color: #fff;
      margin-top: 20px;
      padding: 30px;
      .form-search {
        display: flex;
        align-items: center;

        .clearBtn {
          margin-left: 7px;
          color: #ff904d;
          text-decoration: underline;
        }

        .el-input__inner {
          border: 1px solid #e5e7eb;
          border-radius: 4px;
        }
      }

      .courseForm {
        margin-top: 25px;

        >p.font_16 {
          padding-bottom: 10px;
        }

        .courseList {

          //margin:0 15px;
          >p.font_24_bold {
            margin: 15px 0;
          }

          .classList {
            margin: 24px 0;
            background: #f9fafb;
            border-radius: 10px;
            padding: 24px 28px;

            .flex_1 {
              flex: 1;
              //height:103px;
            }

            .mt {
              margin: 10px 0 0 0;
              font-family: Arial;
              font-size: 14px;
              font-weight: normal;
              line-height: 20px;
              letter-spacing: 0px;

              color: #666666;
            }

            .titleName {
              width: 100%;

              >img {
                width: 64px;
                height: 64px;
                margin-right: 10px;
                background: #ffffff;
                border-radius: 10px;
                margin-right: 15px;
              }

              >span {
                width: 6px;
                height: 6px;
                border-radius: 2px;
                background: #a5a5a5;
                margin: 0 20px;
              }

              >button {
                height: 36px;
                line-height: 36px;
                padding: 0 10px;
                border: none;
                font-size: 16px;
                background: #e7e7e7;
                border-radius: 7px;
                color: #1d2d3a;
              }

              .color_ora {
                color: #f26942;
                font-size: 14px;
                margin: 0 25px;
              }

              .topic {
                .classTopic {
                  margin-right: 16px;
                }
              }
            }

            .classTimeInfo {

              // margin-left:15px;
              // margin-top:10px;
              .studentList {
                // background: #ffffff;
                // border-radius: 8px;
                margin: 10px 0 20px 0;
                // padding:7px 0;
                flex: 1;
                line-height: 24px;
                width: 500px;
                display: flex;
                flex-wrap: wrap;

                p {
                  width: 230px;
                  margin-right: 20px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  word-break: break-all;
                  display: inline-block;
                  color: #353643;
                  font-size: 16px;

                  &.trial {
                    color: #eb4701;
                  }
                }
              }

              .actBtn {
                width: 100%;
                display: flex;
                flex-direction: row;
                button {
                  // width:200px;
                  height: 50px;
                  margin-right: 24px;
                  padding: 0 16px;
                  border-radius: 8px;
                }

                .enterBtn {
                  width: 277px;
                }

                img {
                  box-shadow: 0px 1px 6px 1px rgba(81, 124, 255, 0.2);
                  border-radius: 50%;
                  cursor: pointer;
                }

                p {
                  color: #ff6440;
                  cursor: pointer;
                  margin-left: 20px;
                }
              }
            }
          }
        }
      }
    }

    .mainclass {
      // background-color: #fff;
      width: 75vw;
      margin-left: 24px;
      border-radius: 16px;
      min-width: 1431px;
    }
  }
}

/deep/ .el-rate__text {
  font-size: 16px;
  height: 22px;
  line-height: 22px;
  font-weight: 400;
  font-family: Arial;
}

/deep/.el-rate__item {
  i {
    font-size: 23px;
    margin-right: 3px;
  }
}

// tab切换
/deep/ .el-tabs--card {
  .el-tabs__header {
    border: none;
    margin: 0;

    // .el-tabs__nav-wrap{
    //   margin-bottom:0;
    // }
    .el-tabs__nav {
      border: none;
      border-radius: 0;

      .el-tabs__item {
        border-bottom: none;
        font-size: 18px;
        color: #a5a5a5;
        margin-left: 4px;
        margin-right: 16px;
        font-family: Arial;
        border-left: none;

        &.is-active {
          border-radius: 8px;
          background: #ff904d;
          color: #ffffff;
        }
      }
    }
  }

  .el-tabs__content {
    background: #fff;
    //border: 1px solid #ffd1c6;
    border-radius: 6px;

    .el-tab-pane {
      margin: 20px 13px 15px;
    }
  }
}

// 日历
/deep/ .el-date-editor--daterange {
  width: 375px;
  height: 40px;
  border: none;
  border-bottom: 1px solid #a5a5a5;
  border-radius: 0;

  input,
  span {
    line-height: 35px;
  }

  input {
    width: 26%;
    text-align: left;
  }

  .el-range-separator {
    color: #979797;
    font-size: 14px;
    font-family: Arial;
  }

  .el-icon-date,
  .el-range__close-icon {
    display: none;
  }
}

/deep/ .el-dialog__footer {
  text-align: center;

  button {
    width: 150px;
    margin-top: 20px;
  }
}

/deep/ .fc {
  max-width: 1100px;
  margin: 0 auto;
  font-family: Arial;

  /* 按钮样式 */
  .fc-state-default {
    width: 70px;
    margin: 0 10px;
    background: #fff;
    color: #353643;
    border: none;
    border-radius: 10px !important;
    outline: none;
  }

  .fc-event {
    bottom: initial !important;

    i {
      font-weight: normal;
      font-size: 12px;
    }
  }

  /* 按钮选中的样式 */
  .fc-toolbar .fc-state-active,
  .fc-toolbar .fc-state-active:hover {
    background: #ff904d;
    color: #fff;
    border: none;
  }

  /* 取消待办事项的默认样式 */
  .fc-event,
  .fc-event-dot {
    background: none;
    color: #000;
    font-size: 14px;
  }

  /* 文字颜色 */
  .fc-event,
  .fc-event:hover,
  .fc-v-event .fc-event-main,
  .fc-h-event .fc-event-main {
    color: #000;
  }

  td.fc-today {
    background: #ffdac3;
  }

  .fc-event {
    border: none;
    margin: 5px 0;
  }

  /* 高速自适应没生效 */
  .fc .fc-timegrid-slot {
    height: auto;
  }

  /* 让上方的按钮显示在同一行 */
  .fc .fc-toolbar>*> :first-child {
    display: flex;
  }

  /* 显示的问题设置 */
  p span {
    width: 11px;
    height: 10px;
    background: #cacced;
    border-radius: 7px;
    display: inline-block;
  }

  i {
    font-style: normal;
  }
}

/deep/.fc-event-container {
  text-align: center;

  a {
    width: 80%;
    display: inline-block;
    text-align: left;
    padding: 4px 8px;
  }
}

/deep/.isToday {
  background-color: #fef2f2 !important;
}

/deep/.course_ {
  background: none;
  //margin: 0 !important;
}

/deep/#coursestyle {
  .el-tabs__content {
    background: none !important;
  }
}

/deep/.editNameDialog {
  background: #fffae5;

  .el-dialog__header {
    padding: 46px 24px 24px 24px;
  }

  .el-dialog__body {
    padding: 0 20px !important;

    .el-input__inner::placeholder {
      font-family: Arial;
      font-size: 14px;
      font-weight: normal;
      line-height: 28px;
      letter-spacing: 0px;
      color: rgba(0, 0, 0, 0.3);
    }
  }

  .el-dialog__footer {
    .dialog-footer {
      button {
        width: 100%;
        background: #ff904d;
        box-shadow: none;
        border-radius: 8px;
      }
    }
  }
}

/deep/ .cancelDialog {
  margin-top: 36vh !important;
  background: #fffae5;

  .el-dialog__header {
    padding: 40px 30px 0;

    .el-dialog__title {
      font-size: 20px;
      font-weight: 100;
    }
  }

  .el-dialog__body {
    padding: 22px 30px 0 !important;
    color: #ff904d;
    font-size: 20px;
    font-weight: 100;
  }

  .cancelbtn1 {
    width: 200px;
    color: #000;
    background-color: transparent;
    border: 1px solid #ccc;
  }

  .Confirmbtn1 {
    width: 200px;
    color: #fff;
  }
}

.c6B7280 {
  font-family: Arial;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0px;

  color: #6b7280;
}

.datestyle {
  font-family: Arial;
  font-size: 18px;
  font-weight: normal;
  line-height: 28px;
  letter-spacing: 0px;

  color: #333333;
}

.start_endtime {
  font-family: Arial;
  font-size: 18px;
  font-weight: normal;
  line-height: 28px;
  letter-spacing: 0px;

  color: #333333;
}

.card_tr {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 8px;
  position: relative;

  .card_subtitle {
    font-family: Arial;
    font-size: 16px;
    font-weight: normal;
    line-height: 24px;
    letter-spacing: 0px;

    color: #333333;
  }

  .card_lessons {
    font-family: Arial;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    display: inline-block;
    color: #666666;
    margin-left: 12px;
  }

  .card_leveltitle {
    padding: 4px 8px;
    background: #e5e7eb;
    font-family: Arial;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    display: inline-block;
    border-radius: 8px;
    border: none;
    margin-left: 8px;
    color: #333333;
  }

  .card_levelbtn {
    padding: 10px 14px;
    background: #ff904d;
    font-family: Arial;
    font-size: 14px;
    font-weight: normal;
    border-radius: 8px;
    border: none;
    color: #fff;
    position: absolute;
    right: 10px;
  }

  .card_student {
    font-family: Arial;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    display: inline-block;
    margin-left: 18.6px;
    color: #2563eb;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue